import React from 'react';
import { Typography } from 'housecall-ui';

import { Cart } from '../components/Cart/Cart';
import { CategoryList } from '../components/CategoryList';
import { Layout } from '../components/Layout';
import { StepProgressBar } from '../components/StepProgressBar';

import { WarningMessage } from './WarningMessage';

export const CategoryStep = () => {
  return (
    <Layout
      ContentComponent={
        <>
          <WarningMessage />
          <Typography gutterBottom variant="h5">
            What can we do for you?
          </Typography>
          <CategoryList />
        </>
      }
      Header={
        <>
          <StepProgressBar currentStep={1} stepCount={5} />
          <Cart />
        </>
      }
    />
  );
};

CategoryStep.hiddenButtons = true;
